export default "__VITE_ASSET__YMeAgyax__"